import _possibleConstructorReturn from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _get from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import MonotoneChainSelectAction from '../../index/chain/MonotoneChainSelectAction';
import MonotoneChain from '../../index/chain/MonotoneChain';
import ItemVisitor from '../../index/ItemVisitor';
var MCIndexPointSnapper = /*#__PURE__*/function () {
  function MCIndexPointSnapper() {
    _classCallCheck(this, MCIndexPointSnapper);
    MCIndexPointSnapper.constructor_.apply(this, arguments);
  }
  _createClass(MCIndexPointSnapper, [{
    key: "snap",
    value: function snap() {
      if (arguments.length === 1) {
        var hotPixel = arguments[0];
        return this.snap(hotPixel, null, -1);
      } else if (arguments.length === 3) {
        var _hotPixel = arguments[0],
          parentEdge = arguments[1],
          hotPixelVertexIndex = arguments[2];
        var pixelEnv = _hotPixel.getSafeEnvelope();
        var hotPixelSnapAction = new HotPixelSnapAction(_hotPixel, parentEdge, hotPixelVertexIndex);
        this._index.query(pixelEnv, new ( /*#__PURE__*/function () {
          function _class() {
            _classCallCheck(this, _class);
          }
          _createClass(_class, [{
            key: "visitItem",
            value: function visitItem(item) {
              var testChain = item;
              testChain.select(pixelEnv, hotPixelSnapAction);
            }
          }, {
            key: "interfaces_",
            get: function get() {
              return [ItemVisitor];
            }
          }]);
          return _class;
        }())());
        return hotPixelSnapAction.isNodeAdded();
      }
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._index = null;
      var index = arguments[0];
      this._index = index;
    }
  }]);
  return MCIndexPointSnapper;
}();
export { MCIndexPointSnapper as default };
var HotPixelSnapAction = /*#__PURE__*/function (_MonotoneChainSelectA) {
  _inherits(HotPixelSnapAction, _MonotoneChainSelectA);
  function HotPixelSnapAction() {
    var _this;
    _classCallCheck(this, HotPixelSnapAction);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(HotPixelSnapAction).call(this));
    HotPixelSnapAction.constructor_.apply(_assertThisInitialized(_assertThisInitialized(_this)), arguments);
    return _this;
  }
  _createClass(HotPixelSnapAction, [{
    key: "isNodeAdded",
    value: function isNodeAdded() {
      return this._isNodeAdded;
    }
  }, {
    key: "select",
    value: function select() {
      if (arguments.length === 2 && Number.isInteger(arguments[1]) && arguments[0] instanceof MonotoneChain) {
        var mc = arguments[0],
          startIndex = arguments[1];
        var ss = mc.getContext();
        if (this._parentEdge === ss) if (startIndex === this._hotPixelVertexIndex || startIndex + 1 === this._hotPixelVertexIndex) return null;
        this._isNodeAdded |= this._hotPixel.addSnappedNode(ss, startIndex);
      } else {
        return _get(_getPrototypeOf(HotPixelSnapAction.prototype), "select", this).apply(this, arguments);
      }
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._hotPixel = null;
      this._parentEdge = null;
      this._hotPixelVertexIndex = null;
      this._isNodeAdded = false;
      var hotPixel = arguments[0],
        parentEdge = arguments[1],
        hotPixelVertexIndex = arguments[2];
      this._hotPixel = hotPixel;
      this._parentEdge = parentEdge;
      this._hotPixelVertexIndex = hotPixelVertexIndex;
    }
  }]);
  return HotPixelSnapAction;
}(MonotoneChainSelectAction);
MCIndexPointSnapper.HotPixelSnapAction = HotPixelSnapAction;